import styled from '@emotion/styled';

export const StyledProductActions = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spaces[2],
}));
